<app-dialog 
    [header]="header"
    [subHeader]="subHeader"
    [hideHeaderUnderline]="true"
    [show]="true"
>
    <app-signature-pad [class.hidden]="currentStep.id !== PinAndSignatureProgress.Signature"
        #signaturePad
        [readonly]="signerSignaturePadReadOnly"
        (drawEnd)="drawComplete($event)"
        (cleared)="signatureCleared()"
    ></app-signature-pad>
     <app-signature-pad [class.hidden]="currentStep.id !== PinAndSignatureProgress.WitnessSignature"
        #witnessSignaturePad 
        [readonly]="witnessSignaturePadReadOnly"
        (drawEnd)="witnessDrawComplete($event)"
        (cleared)="witnessSignatureCleared()"
    ></app-signature-pad>
    <app-enter-pin-dialog *ngIf="showPinDialog"
        #pinUser
        [focusPin]="true"
        [show]="true"
        [isWitness]="false"
        [withAbilityToReset]="false"
        (setPinHandler)="afterPinHandled($event)"
    ></app-enter-pin-dialog>

    <app-enter-pin-dialog  *ngIf="showWitnessPinDialog"
        #pinWitness
        [focusPin]="true"
        [show]="true"
        [isWitness]="true"
        (setPinHandler)="afterWitnessPinHandled($event)"
    ></app-enter-pin-dialog>


    <div class="dialog-controls-default">
        <app-button customClasses="px-4"
                    text="Cancel"
                    [minWidth]="0"
                    subStyle="transparent"
                    class="cancel-btn"
                    (clicked)="cancel.emit()"
        >
        </app-button>
    
        <app-dot-progress-indicator
          [steps]="steps"
          (stepActivated)="stepSelected($event)"
          #stepper
        >
        </app-dot-progress-indicator>
        <app-button customClasses="px-4" *ngIf="currentStep.id === PinAndSignatureProgress.Signature"
            text="Pin"
            class="save-btn"
            icon="icon-chevron-white"
            [disabled]="!singerSignature || signerPin"
            [minWidth]="85"
            [iconPosition]="ButtonIconPositions.Right"
            (clicked)="openSignerPin()"
        >
        </app-button>
        <app-button customClasses="px-4" *ngIf="currentStep.id === PinAndSignatureProgress.WitnessSignature"
            text="Witness Pin"
            class="save-btn"
            [disabled]="!singerSignature || !signerPin || !witnessSignature || witnessPin"
            icon="icon-chevron-white"
            [iconPosition]="ButtonIconPositions.Right"
            (clicked)="openWitnessPin()"
        >
        </app-button>
    </div>
</app-dialog>
